import React from "react";
import { Navigate} from "react-router-dom";

const AuthProtected = (props: any) => {
  // const { userProfile, loading } = useProfile();
  /*
    redirect is un-auth access protected routes via url
    */
  if (!localStorage.getItem('loginData')) {
    return (
      <Navigate to={"/login"} />
    );
  }

  return <>{props.children}</>;
};
export { AuthProtected };
